import AssociateReferalTeam from "./AssociateReferalTeam";
import Business from "./Business";
import Commision from "./Commision";
import Rank from "./Rank";
import SliderBanner from "./Slider";
import hiImg from "../../../../assets/img/hi.svg";
import GreetingsComponet from "../../../../CommonComponets/GreetingsComponet/GreetingsComponet";
import { useNavigate } from "react-router-dom";
import useApiRequest from "../../../../Hooks/apiReq";
import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import ApiEncryptDecrypt from "../../../../Utils/Encryption";
import { FaAddressCard } from "react-icons/fa";
import Buttonbox from "../../../../Shared/ButtonBox/Buttonbox";
import { GiCheckMark } from "react-icons/gi";
import { BsMicrosoftTeams } from "react-icons/bs";
import { useSelector } from "react-redux";
import UpdatedNews from "./UpdatedNews";
import Project from "./Project";
import { projects } from "../../constant/ProjectsData";
import DashboardSkeleton from "../../../OrgEcommerce/Pages/Dashboard/DashboardSkeleton";
import Projects from "./ProjectsList";
const DashboardBisiness = () => {
  const { error, loading, recallRequest, response, sendApiRequest } =
    useApiRequest();
  const [data, setData] = React.useState([]);
  const navigate = useNavigate();
  const associateProfileDetails = useSelector(
    (state) => state.assoProfileDetails.profileDetails,
  );
  const getUpdatedNewslist = () => {
    sendApiRequest("POST", "/Dashboard/GetNewsList", "", {
      onSuccess: (res) => {
        const ParsedData = res?.data?.jsonData
          ? JSON.parse(res?.data?.jsonData)
          : [];
        setData(ParsedData);
        // console.log(res);
      },
      onStatus3: () => {
        navigate("/login");
      },
    });
  };
  useEffect(() => {
    getUpdatedNewslist();
  }, []);
  const Key = import.meta.env.VITE_Encryption_Decryption_Key;
  const [btnType, setCopiedBtn] = useState("");
  const handleCustomerCopyLink = useCallback(async () => {
    const data = await ApiEncryptDecrypt.encryptString(
      Key,
      associateProfileDetails?.assoCode,
    );
    let link = `https://customer.ravgroup.org/customer-registration?id=${data}`;
    navigator.clipboard.writeText(link);
    toast.success("Customer Link Copied Successfully", {
      toastId: "cust",
    });
  }, [associateProfileDetails]);

  const handleAssociateCopyLink = useCallback(async () => {
    const data = await ApiEncryptDecrypt.encryptString(
      Key,
      associateProfileDetails?.assoCode,
    );
    let link = `https://cp.tantrash.com/add-associate-by-ref?id=${data}`;
    navigator.clipboard.writeText(link);
    toast.success("Associate Link Copied Successfully", {
      toastId: "asso",
    });
  }, [associateProfileDetails]);

  const handleRAVDownloadCopyLink = async () => {
    const data = await ApiEncryptDecrypt.encryptString(
      Key,
      associateProfileDetails?.assoCode,
    );

    let link = `https://ravdownload.in/referral-joining?id=${encodeURIComponent(
      data,
    )}`;
    navigator.clipboard.writeText(link);
    toast.success("RAV Download Customer Link Copied Successfully", {
      toastId: "Download",
    });
  };

  const handleRAVOrganicCopyLink = async () => {
    const data = await ApiEncryptDecrypt.encryptString(
      Key,
      associateProfileDetails?.assoCode,
    );

    let link = `https://ravorganics.com/referral-joining?id=${encodeURIComponent(
      data,
    )}`;
    navigator.clipboard.writeText(link);
    toast.success("RAV Organic Customer  Link Copied Successfully", {
      toastId: "Organic",
    });
  };

  const handleCopy = useCallback((type, callback) => {
    setCopiedBtn(type);
    callback();
    setTimeout(() => {
      setCopiedBtn("");
    }, 2000);
  }, []);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Set a timer to stop loading after 2 seconds
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    // Proper cleanup: prevents memory leaks if component unmounts
    return () => clearTimeout(timer);
  }, []);

  // Logic to decide what to show
  if (isLoading) {
    return <DashboardSkeleton />;
  }

  return (
    <main class="main" id="top">
      <div class="content">
        <div class="row mb-2 ">
          {/* <div class="col-lg-12 bg-white shadow-sm">
            <marquee
              behavior="scroll"
              direction="left"
              onmouseover="this.stop()"
            >
              <ul className="d d-flex gap-5">
                {data?.map((item, index) => (
                  <li className="  fw-bold" key={index}>
                    {item?.News}
                  </li>
                ))}
              </ul>
            </marquee>
          </div> */}
          <NewsTicker data={data} />
          <div className="col-xxl-6 col-12">
            <div className="nav-searchinputs">
              <img src={hiImg} alt="" />
              <span>
                Hi ,{associateProfileDetails?.solutation}{" "}
                {associateProfileDetails?.fullName}(
                <strong className=" fw-bold">
                  {associateProfileDetails?.assoCode}
                </strong>
                )
              </span>
              <GreetingsComponet />
            </div>
          </div>
          <div className="col-xxl-6 col-12">
            <div className="d-flex flex-wrap w-100 justify-content-lg-end">
              <a className="me-2" title="Here's your Associate Referral Link.">
                <Buttonbox
                  text={
                    btnType != "associate" ? "Copy Associate Link" : "Copied"
                  }
                  removeIcon={
                    btnType != "associate" ? (
                      <BsMicrosoftTeams />
                    ) : (
                      <GiCheckMark
                        className="text-success fw-bolder "
                        size={16}
                      />
                    )
                  }
                  handleClick={() =>
                    handleCopy("associate", handleAssociateCopyLink)
                  }
                  className="mx-2 btn btn-secondary mt-1 bg-gradient rounded-pill w-100 btn-sm"
                >
                  {" "}
                </Buttonbox>
              </a>

              <a title="Here's your Customer Referral Link.">
                <Buttonbox
                  text={btnType != "customer" ? "Copy Customer Link" : "Copied"}
                  removeIcon={
                    btnType != "customer" ? (
                      <FaAddressCard />
                    ) : (
                      <GiCheckMark
                        className="text-success fw-bolder"
                        size={16}
                      />
                    )
                  }
                  handleClick={() =>
                    handleCopy("customer", handleCustomerCopyLink)
                  }
                  className="ms-2 pe-3 btn mt-1 btn-secondary rounded-pill  customerLink bg-gradient w- 100 btn-sm"
                >
                  {" "}
                </Buttonbox>
              </a>

              <a title="Here's Your RAV Download Customer Referral Link.">
                <Buttonbox
                  text={btnType != "download" ? "RAV Dowload Link" : "Copied"}
                  removeIcon={
                    btnType != "download" ? (
                      <BsMicrosoftTeams />
                    ) : (
                      <GiCheckMark
                        className="text-success fw-bolder"
                        size={16}
                      />
                    )
                  }
                  handleClick={() =>
                    handleCopy("download", handleRAVDownloadCopyLink)
                  }
                  className="mx-2 btn btn-secondary bg-gradient mt-1 rounded-pill RAVDownloadCustomerLink btn-sm"
                >
                  {" "}
                </Buttonbox>
              </a>

              <a title="Here's  Your RAV Organic Customer Referral Link.">
                <Buttonbox
                  text={btnType != "organic" ? "RAV Organic Link" : "Copied"}
                  removeIcon={
                    btnType != "organic" ? (
                      <BsMicrosoftTeams />
                    ) : (
                      <GiCheckMark
                        className="text-success fw-bolder"
                        size={16}
                      />
                    )
                  }
                  handleClick={() =>
                    handleCopy("organic", handleRAVOrganicCopyLink)
                  }
                  className="mx-2 btn btn-secondary mt-1  bg-gradient RAVOrganicCustomerLink  rounded-pill btn-sm"
                >
                  {" "}
                </Buttonbox>
              </a>
            </div>
          </div>
        </div>
        <div className="row gy-3 mb-6">
          {/* banner Part */}
          <SliderBanner />
          {/* //updated News  */}
          <UpdatedNews />
          <Business />
          <Commision />
          <Rank />
          <AssociateReferalTeam />
          <Projects />
          {projects?.map((item, idx) => (
            <Project
              ratio={idx == projects.length - 1 ? true : false}
              project={item}
            />
          ))}
        </div>
      </div>
    </main>
  );
};
export default DashboardBisiness;

export const NewsTicker = ({ data }) => {
  console.log(data, "updated news");

  return (
    <div className="container-fluid  pb-1     ">
      <div className="row">
        <div
          className="col-lg-12  bg-gradient bg-light    d-flex align-items-center p-0 overflow-hidden"
          style={{ height: "40px" }}
        >
          {/* Static Green Label */}
          <div
            className="bg-success text-white px-4 h-100 d-flex align-items-center fw-bold position-relative"
            style={{
              minWidth: "180px",
              minHeight: "40px",
              zIndex: 10,
              fontSize: "14px",
            }}
          >
            UPDATED NEWS
            <div className="ticker-arrow"></div>
          </div>

          {/* Scrolling Content */}
          <marquee
            behavior="scroll"
            direction="left"
            onMouseOver={(e) => e.currentTarget.stop()}
            onMouseOut={(e) => e.currentTarget.start()}
            className="flex-grow-1"
          >
            <ul className="d-flex align-items-center list-unstyled m-0 gap-5 py-2">
              {data?.map((item, index) => (
                <li
                  className="d-flex align-items-center  gap-3 text-secondary"
                  key={index}
                  style={{ whiteSpace: "nowrap" }}
                >
                  <span style={{ color: "#2c2e50" }}>●</span>
                  {/* <span className="fw-semibold text-dark">
                    {item?.News || "Test Meeting on 12th April 2025"}
                  </span> */}
                  <span
                    dangerouslySetInnerHTML={{
                      __html: item?.News || "Test Meeting on 12th April 2025",
                    }}
                  />
                  <span className="fw-bold text-dark">
                    {item?.Date || "Tue, 01 Apr 2025"}
                  </span>
                </li>
              ))}
            </ul>
          </marquee>
        </div>
      </div>
    </div>
  );
};
